class StickyBuyButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const stickyBar = this.querySelector('.sticky-buy-button__container');

    this._wireBuildABox(stickyBar);

    const productSection = document.querySelector('.product');
    const footer = document.querySelector('footer');

    const updateVisibility = () => {
      const productVisible = this._isElementInViewport(productSection);
      const footerVisible = this._isElementInViewport(footer);

      if (!productVisible && !footerVisible) {
        stickyBar.classList.remove('hidden');
      } else {
        stickyBar.classList.add('hidden');
      }
    };

    const observer = new IntersectionObserver(updateVisibility, {
      threshold: [0],
    });

    observer.observe(productSection);
    observer.observe(footer);

    window.addEventListener('scroll', updateVisibility);
    window.addEventListener('resize', updateVisibility);
  }

  _isElementInViewport(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight);
  }

  _wireBuildABox(stickyBar) {
    if (!stickyBar) return;
    const stickyBtn = stickyBar.querySelector('button');
    if (!stickyBtn) return;

    const box = document.querySelector('.build-a-box');
    const boxAddBtn = box && box.querySelector('[data-add-to-cart]');
    if (!boxAddBtn) return;

    stickyBtn.setAttribute('type', 'button');
    stickyBtn.removeAttribute('form');
    stickyBtn.removeAttribute('name');

    const stickyLabelSpan = stickyBtn.querySelector('span');
    const boxLabelEl = boxAddBtn.querySelector('.build-a-box__add-button-text');

    const syncFromBox = () => {
      stickyBtn.disabled = boxAddBtn.disabled;
      if (boxLabelEl && stickyLabelSpan) {
        const textNode = Array.from(stickyLabelSpan.childNodes).find((n) => n.nodeType === Node.TEXT_NODE);
        if (textNode) textNode.nodeValue = boxLabelEl.textContent;
      }
    };

    syncFromBox();

    const observer = new MutationObserver(syncFromBox);
    observer.observe(boxAddBtn, { attributes: true, attributeFilter: ['disabled'] });
    if (boxLabelEl) {
      observer.observe(boxLabelEl, { childList: true, characterData: true, subtree: true });
    }

    stickyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (boxAddBtn.disabled) return;
      boxAddBtn.click();
    });
  }
}

customElements.define('sticky-buy-button', StickyBuyButton);
